type EventProperties = Record<string, string | number | boolean>;

const apiKey = process.env.REACT_APP_POSTHOG_KEY;
const apiHost =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const enabled = process.env.NODE_ENV === 'production' && Boolean(apiKey);
let clientPromise: Promise<any> | null = null;

const getClient = () => {
  if (!enabled) return null;
  if (!clientPromise) {
    clientPromise = import('posthog-js').then(module => {
      const client = module.default;
      client.init(apiKey!, {
        api_host: apiHost,
        autocapture: false,
        capture_pageview: true,
        capture_pageleave: true,
        disable_session_recording: true,
      });
      client.register({ app: 'planning' });
      return client;
    });
  }
  return clientPromise;
};

export const initAnalytics = () => {
  getClient();
};

export const track = (event: string, properties: EventProperties = {}) => {
  const client = getClient();
  if (!client) return;
  client.then(posthog => posthog.capture(event, properties));
};
